import {RoleEnum} from "./enums/role-enum";
import {Permissao} from "../tipos/permissao";

export const permissoes: Permissao[] = [
  {
    role: RoleEnum.ADM,
    cor:  "red.8"
  },
  {
    role: RoleEnum.FINANCEIRO,
    cor:  "orange.8"
  },
  {
    role: RoleEnum.USUARIO,
    cor:  "blue.5"
  },
  {
    role: RoleEnum.COORDENADOR,
    cor:  "cyan.8"
  },
  {
    role: RoleEnum.ASPLAN_FORCA,
    cor:  "indigo.8"
  },
  {
    role: RoleEnum.CADASTRAR_CONSULTA_CIRAST,
    cor:  "lime.7"
  },
  {
    role: RoleEnum.CADASTRAR_CLINICA_CIRAST,
    cor:  "teal.7"
  },
  {
    role: RoleEnum.GERAR_RELATORIO_CIRAST,
    cor:  "yellow.6"
  },
]

export function getPermissao(role: RoleEnum) {
  return permissoes.find(r => r.role === role);
}
